import React from "react"
import { Typography, Box, CircularProgress } from "@mui/material"

const AuthenticationProgress = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress />
      <Box mt={2}>
        <Typography variant="h6" component="div">
          Authentication in progress...
        </Typography>
      </Box>
    </Box>
  )
}

export default AuthenticationProgress
